import { render, staticRenderFns } from "./GetMerchant.vue?vue&type=template&id=a92cd864&"
import script from "./GetMerchant.vue?vue&type=script&lang=js&"
export * from "./GetMerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports